import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { confirmBookingPresence } from '../lib/bookings';
import { bookingsQueryKeys } from '../query-keys/bookings';

export const useConfirmBookingPresence = (onSuccess?: () => void) => {
  const { t } = useTranslation(['bookings', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      bookingToken,
      spaceToken,
    }: {
      bookingToken: string;
      spaceToken: string;
    }) => confirmBookingPresence(bookingToken, spaceToken),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: bookingsQueryKeys.lists(),
        });
      });
      toast.success(t('bookings:common.confirmPresenceDialog.successMessage'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      const errorMessage = error?.response?.data?.message;

      toast.error(errorMessage || t('common:errorMessages.somethingWentWrong'));
    },
  });
};
